import { bindResource } from './bindResource';
import { getResourceList } from './getResourceList';

export { bindResource, getResourceList };
